<template>
  <div>
    <div class="product-desc-content">
      <h3>Test e sondaggi</h3>
      <button class="btn btn-outline-primary mb-2" data-toggle="modal" data-target="#modal-test">
        Nuovo test
      </button>
      <div id="testcomponent">
        <div v-for="test in tests" :key="test.id">
          <blockquote class="blockquote blockquote-custom bg-white p-5 shadow rounded">
            <div class="blockquote-custom-icon bg-info shadow-sm p-3" style="font-size: 23px">
              {{ test.request }} <span style="font-size: 18px"></span>({{
                test.created_at
              }})
            </div>
            <p class="mb-0 mt-2 font-italic">
              <span v-if="test.archive == 1"> (ARCHIVIATO)</span><br /><br />
              <span v-if="!test.response_enable" class="mt-4">
                (HAI RISPOSTO AL TEST)</span>
              <span v-if="
                test.test_response != null && test.test_response.vote != null
              ">
                <br /><br />
                Voto:
                <span v-for="star in test.test_response.vote" :key="star" class="star"
                  :class="{ filled: star <= test.test_response.vote }" style="color: #ffde03">
                  ★
                </span>
                <span v-for="star in 5 - test.test_response.vote" :key="star" class="star"
                  :class="{ filled: star <= test.test_response.vote }" style="color: #e0e0e0">
                  ★
                </span>
              </span>
            </p>
            <div v-if="
              test.type_request == 3 &&
              !test.is_property_test &&
              !test.response_enable
            ">
              <button type="button" class="btn btn-primary" @click="openChart(test.id)">
                Guarda i risultati
              </button>
            </div>
            <div v-if="!test.is_property_test">
              <div v-if="test.archive == 0 && test.response_enable">
                <div v-if="test.type_request == 1" class="mt-2">
                  <textarea class="form-control" rows="2" maxlength="255" v-model="responses"
                    placeholder="Inserisci la tua risposta"></textarea>
                  <div class="text-right">
                    <button type="button" class="btn btn-primary" @click="sendResponse(test)">
                      Conferma la risposta
                    </button>
                  </div>
                </div>
                <div v-if="test.type_request == 2 || test.type_request == 3">
                  <div v-for="(response, key) in test.responses" :key="key">
                    <div class="form-control" v-if="response !== null">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios"
                          :id="'exampleRadios1' + test.id" v-model="responses" :value="key" />
                        <label class="form-check-label" :for="'exampleRadios1' + test.id">
                          &nbsp; {{ response }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="text-right">
                    <button type="button" class="btn btn-primary" @click="sendResponse(test)">
                      Conferma la risposta
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row d-flex justify-content-center">
                <div v-if="test.archive == 0">
                  <button type="button" class="btn btn-info" @click="archiveTest(test)">
                    Archivia il test
                  </button>
                </div>

                <div v-if="test.response_count > 0" class="ml-2">
                  <router-link :to="'/test/result/' + test.id" class="btn btn-primary">Analizza le
                    risposte</router-link>
                </div>

                <div v-if="test.type_request == 3">
                  <button type="button" class="btn btn-primary ml-2" @click="openChart(test.id)">
                    Guarda i risultati
                  </button>
                </div>
              </div>
            </div>
          </blockquote>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" id="modal-test"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 90%; max-height: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title justify-content-center">Nuovo test</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-test">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="sendTest">
            <div class="modal-body">
              <div class="m-4">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="domanda_test_intervista">Domanda</label>

                      <input type="text" class="form-control" id="domanda_test_intervista"
                        placeholder="Inserisci la tua nuova domanda" v-model="testRequest.request" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="tipo_risposta_intervista">Che tipo di test vuoi effettatuare?</label>

                      <select @change="changeCountry($event)" class="form-control">
                        <option v-for="opt in typeTest" :key="opt.id" v-bind:value="opt.id">
                          {{ opt.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <hr />
                <div v-if="
                  testRequest.type_request == 3 ||
                  testRequest.type_request == 2
                ">
                  <div class="row">
                    <div :class="testRequest.type_request == 2 ? 'col-md-3' : 'col-md-4'
                      ">
                      <div class="form-group">
                        <label for="risposta_1_intervista">Risposta 1 </label>
                        <input type="text" class="form-control" id="risposta_1_intervista"
                          v-model="testRequest.responses.response_1"
                          placeholder="Inserisci la risposta 1 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_1">
                          {{ errors.responses.response_1[0] }}
                        </div>
                      </div>
                    </div>
                    <div :class="testRequest.type_request == 2 ? 'col-md-3' : 'col-md-4'
                      ">
                      <div class="form-group">
                        <label for="risposta_2_intervista">Risposta 2</label>
                        <input type="text" class="form-control" id="risposta_2_intervista"
                          v-model="testRequest.responses.response_2"
                          placeholder="Inserisci la risposta 2 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_2">
                          {{ errors.responses.response_2[0] }}
                        </div>
                      </div>
                    </div>
                    <div :class="testRequest.type_request == 2 ? 'col-md-3' : 'col-md-4'
                      ">
                      <div class="form-group">
                        <label for="risposta_3_intervista">Risposta 3</label>
                        <input type="text" class="form-control" id="risposta_3_intervista"
                          v-model="testRequest.responses.response_3"
                          placeholder="Inserisci la risposta 1 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_3">
                          {{ errors.responses.response_3[0] }}
                        </div>
                      </div>
                    </div>
                    <div :class="testRequest.type_request == 2 ? 'col-md-3' : 'col-md-6'
                      ">
                      <div class="form-group">
                        <label for="risposta_4_intervista">Risposta 4</label>
                        <input type="text" class="form-control" id="risposta_4_intervista"
                          v-model="testRequest.responses.response_4"
                          placeholder="Inserisci la risposta 4 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_4">
                          {{ errors.responses.response_4[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="risposta_5_intervista">Risposta 5</label>
                        <input type="text" class="form-control" id="risposta_5_intervista"
                          v-model="testRequest.responses.response_5"
                          placeholder="Inserisci la risposta 5 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_5">
                          {{ errors.responses.response_5[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="testRequest.type_request == 2">
                      <div class="form-group">
                        <label for="risposta_5_intervista">Risposta corretta</label>
                        <select v-model="testRequest.correct_response" class="form-control">
                          <option value="0" selected disabled>
                            Seleziona una risposta
                          </option>

                          <option v-for="opt in responseOptions" :key="opt.value" v-bind:value="opt.value">
                            {{ opt.text }}
                          </option>
                        </select>
                        <div class="alert alert-danger" v-if="errors.correct_response">
                          {{ errors.correct_response[0] }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                Pubblica il test
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End .product-desc-content -->

    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" id="pie-chart-modal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 90%; max-height: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Grafico</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Bar v-if="loaded" :data="chartData" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import httpauth from "@/services/httpauth.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);
export default {
  name: "TestComponent",
  props: ["activity_id_params"],
  components: { Bar },
  data() {
    return {
      tests: [],
      intervalId: null,
      testRequest: {
        activity_id: 0,
        request: "",
        type_request: 1,
        responses: {
          response_1: "",
          response_2: "",
          response_3: "",
          response_4: "",
          response_5: "",
        },
        correct_response: 0,
      },
      responses: [],
      typeTest: [
        { id: 1, value: "Risposta aperta" },
        { id: 2, value: "Risposta multipla" },
        { id: 3, value: "Sondaggio di opinioni" },
      ],
      responseOptions: [
        { value: 1, text: "Seleziona la prima risposta" },
        { value: 2, text: "Seleziona la seconda risposta" },
        { value: 3, text: "Seleziona la terza risposta" },
        { value: 4, text: "Seleziona la quarta risposta" },
        { value: 5, text: "Seleziona la quinta risposta" },
      ],
      errors: [],
      correct_response: [],
      cssClassCreateRequest: "",
      loaded: false,
      chartData: null,
    };
  },
  mounted() {
    $(document).on("show.bs.modal", ".modal", function () {
      $(this).appendTo("body");
    });
  },
  created() {
    this.loadTests(this.activity_id_params);
    this.intervalId = setInterval(() => {
      if (this.activity_id_params)
      {
        this.loadTests(this.activity_id_params);
      }

    }, 32000);
  },
  beforeUnmount() {
    // pulisce l'intervallo quando il componente viene distrutto
    clearInterval(this.intervalId);
  },
  methods: {
    loadTests(activity_id) {
      httpauth
        .get("/test/" + activity_id)
        .then((response) => {
          this.tests = response.data.data;
        })
        .catch({});
    },
    openChart(id) {
      httpauth.get("/test-response/get-stats/" + id).then((response) => {
        this.chartData = {
          labels: response.data.data.label,
          datasets: [
            {
              label: "Data One",
              backgroundColor: "#f87979",
              data: response.data.data.value,
            },
          ],
        };

        this.loaded = true;

        $("#pie-chart-modal").modal("show");
      });
    },
    changeCountry(event) {
      this.testRequest.type_request = event.target.value;
    },
    async sendResponse(testRequest) {
      const response = {
        test_request_id: testRequest.id,
        response: this.responses,
      };
      await httpauth
        .post("/test-reponse/store", response)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
          for (var i = 0; i < this.tests.length; i++)
          {
            if (this.tests[i].id == testRequest.id)
            {
              this.tests[i].response_enable = false;
              break;
            }
          }
        })
        .catch((error) => {
          if (
            error.response.data.errors &&
            error.response.data.errors.response[0]
          )
          {
            const $toast = useToast();
            $toast.open({
              message: error.response.data.errors.response[0],
              type: "warning",
              position: "top-right",
              // all of other options may go here
            });
          }
        });
    },
    async sendTest() {
      this.testRequest.activity_id = this.activity_id_params;
      await httpauth
        .post("/test/store", this.testRequest)
        .then((response) => {
          $("#modal-test").modal("hide");
          document.getElementById("close-modal-test").click();
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
          this.loadTests(this.activity_id_params);
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    archiveTest(test) {
      const request = {
        id: test.id,
        archive: test.archive == 1 ? 0 : 1,
      };
      httpauth.post("/test/archive", request).then((response) => {
        const $toast = useToast();
        $toast.open({
          message: response.data.message,
          type: "info",
          position: "top-right",
          // all of other options may go here
        });
        for (var i = 0; i < this.tests.length; i++)
        {
          if (test.id == this.tests[i].id)
          {
            this.tests[i].archive = 1;
          }
        }
      });
    },
  },
};
</script>